import { SEARCHING_STARTED } from '../types'

export const doSetToSearching = () => {
  return {
    type: SEARCHING_STARTED,
  }
}
